import branch from '@/api/administration/branches'

import { baseState, baseMutations } from '@/store/mixins'

export const state = {
  ...baseState
}

export const getters = {}

export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch(context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )
    return branch.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },

  storeBranchProfile(context, data) {
    return branch.store(data)
  },

  update(context, data) {
    return branch.update(data)
  },

  destroy(context, id) {
    return branch.destroy(id)
  }
}
